import { useUserWallets } from "@dynamic-labs/sdk-react-core";

export function useDynamicWallet() {
  const wallets = useUserWallets();
  return wallets[0] ? wallets[0] : undefined;
}
